export default __webpack_public_path__ + "static/media/Pen Test-letter-attestation_DISS-CO_20231006.72da8039.pdf";